import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/service/app.service";
import { EncryptDecryptParametersServiceService } from "src/app/core/service/encrypt-decrypt-parameters-service.service";
import { DoctorService } from "src/app/doctor/doctor.service";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { PrescriptionDetails } from "src/app/shared/models/prescriptionDetails";
import { PrescriptionPatientVM } from "src/app/shared/models/PrescriptionPatientVM";
import { ReplaceModalComponent } from "../replace-modal/replace-modal.component";
import { SummaryModalComponent } from "../summary-modal/summary-modal.component";
import { Location, LocationStrategy } from "@angular/common";
import { PrescriptionService } from "../../prescription.service";
import { AuthService } from "src/app/core/service/auth.service";
import { NotificationService } from "src/app/shared/notification.service";
import { userRole } from "src/app/shared/userRole";
import { UserAccount } from "src/app/shared/models/user-account";
import { ActivityType } from "src/app/shared/ActivityType";
declare var SignaturePad: any;
import { formatDate } from "@angular/common";
import { PatientService } from "src/app/doctor/patient/patient.service";
import { number } from "echarts";

@Component({
  selector: "app-filled-prescription",
  templateUrl: "./filled-prescription.component.html",
  styleUrls: ["./filled-prescription.component.sass"],
})
export class FilledPrescriptionComponent implements OnInit, OnDestroy {
  @ViewChild("printPrescriptionConfirm") printPrescriptionConfirm: TemplateRef<any>;
  @ViewChild("CancelPrescriptionComponent")
  CancelPrescriptionComponent: TemplateRef<any>;
  prescriptionDetails: any;
  drugList: PrescriptionDetails[];
  signaturePads: any;
  currentDate = new Date();
  replacedDrug: any[];
  prescriptionId: any;
  Patient: any;
  oldStatus: any;
  comments: any;
  currentUser: UserAccount;
  replaceItem: any;
  collectionLocationList:any =[];
  collectionLocation: any;
  collectionLocationkey: string[];
  collectionLocationListNew: any[];
  pdfstring: any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private encryptDecryptParametersService: EncryptDecryptParametersServiceService,
    private doctorService: DoctorService,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    private pharmacistService: PharmcistService,
    private location: Location,
    private prescriptionService: PrescriptionService,
    private authService: AuthService,
    private patientService: PatientService,
    private notificationService: NotificationService,
    private locationStrategy: LocationStrategy,
    private _ngZone: NgZone
  ) {
    this.prescriptionDetails = new PrescriptionPatientVM();
    this.replacedDrug = new Array<any>();
    this.currentUser = new UserAccount();
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  ngOnInit(): void {
    const finalURL =
      this.router.url.split("?")[0] +
      "?" +
      this.encryptDecryptParametersService.decrypt(this.router.url);
    var data = JSON.parse(
      this.encryptDecryptParametersService.getQueryParams("details", finalURL)
    );
    this.prescriptionId = data.Id;
    this.oldStatus = data.Status;
    this.getDrugListByPrescriptionId(this.prescriptionId);
    this.subscribeToEvents();
    this.getCollectionLocation();
  }

  replacementModal(row) {
    // TO DO API to  get patient details
    // this.replaceItem = row;
    const dialogRef = this.dialog.open(ReplaceModalComponent, {
      data: {
        drug: row,
        action: "view",
      },
      width: "100%",
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        // var foundIndex = this.prescriptionDetails.drugList.findIndex(
        //   (x) => x.DrugId == result.OldDrugId
        // );
        // this.prescriptionDetails.drugList[foundIndex].DrugName = result?.Name;
        // this.prescriptionDetails.drugList[foundIndex].Description = result?.Description;
        if (result != null && result != undefined) {
          this.replacedDrug.unshift(result);
        }
      },
    });
  }

  summaryModal(row) {
    // TO DO API to  get patient details
    let drugs = [];
    this.replacedDrug.forEach((element) => {
      if (element.OldDrugId == row.DrugId) {
        element.CreatedDate = new Date();
        drugs.push(element);
      }
    });
    var prescribeDrug = {
      Status: "Prescribed",
      CreatedDate: row.CreatedDate,
      Name: row.DrugName,
      Description: row.Description,
      Refill: row.Refill,
      Remark: "-",
    };
    drugs.push(prescribeDrug);
    const dialogRef = this.dialog.open(SummaryModalComponent, {
      data: {
        drug: drugs,
        action: "view",
      },
      width: "100%",
      maxWidth: "750px",
      disableClose: true,
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  getCurrentUserDetails(id) {
    const user = { Id: id };
    this.appService.getUser(user).subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          res.DateOfBirth =
            res.DateOfBirth !== null ? new Date(res.DateOfBirth) : null;
          this.prescriptionDetails.doctorUserAccount = res;
          // this.getDrugListByPrescriptionId(this.prescriptionId);
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getDrugListByPrescriptionId(id) {
    
    this.spinner.show();
    const prescriptionDetails = { prescriptionId: id };
    this.pharmacistService
      .GetDrugListByPrescriptionId(prescriptionDetails)
      .subscribe({
        next: (res) => {
          if (!res.HasErrors) {
            this.spinner.show();
            this.drugList = res.PrescriptionDetails;
            this.prescriptionDetails.drugList = this.drugList;
            this.prescriptionDetails.Doctor = res.Doctor;
            this.prescriptionDetails.Patient = res.Patient;
            this.prescriptionDetails.Prescription = res.Prescription;
            this.prescriptionDetails.doctorUserAccount = null;
            this.comments = this.prescriptionDetails.Prescription.Comment;
            this.getCurrentUserDetails(
              this.prescriptionDetails.Patient.PhysicianAccountId
            );
            this.getReplaceItemListById(
              this.prescriptionDetails.Prescription.Id
            );
            this.spinner.hide();
            if(this.prescriptionDetails.Prescription.CollectionLocation!="" && this.prescriptionDetails.Prescription.CollectionLocation!=null)
            {
              this.collectionLocation = this.prescriptionDetails.Prescription.CollectionLocation
            }
            
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  clearSignature(): void {
    this.signaturePads.clear();
  }
  back() {
    this.CancelPrescription();
  }

  UpdatePrescription() {
    var target = this.prescriptionDetails.drugList.find(
      (x) => x.Status != "PENDING"
    );
    var target2 = this.prescriptionDetails.drugList.find(
      (x) => x.Status != "NOT AVAILABLE"
    );
    if (target && target2) {

     
        this.prescriptionDetails.Prescription.CollectionLocation=this.collectionLocation

      // if (
      //   this.prescriptionDetails.Prescription.Comment != "" &&
      //   this.prescriptionDetails.Prescription.Comment != undefined
      // ) {
      this.prescriptionDetails.Prescription.ModifiedById = this.currentUser.Id;
      var formDetails = {
        Patient: this.prescriptionDetails.Patient,
        Prescription: this.prescriptionDetails.Prescription,
        PrescriptionDetails: this.prescriptionDetails.drugList,
        ReplaceDrugHistories: this.replacedDrug,
      };
      // if (this.prescriptionDetails.Prescription.IsReadyToCollect == false) {
      //   formDetails.ReplaceDrugHistories = [];
      // }
      this.spinner.show();
      var prescriptionDetails = {
        prescriptionDetails: formDetails,
      };
      this.prescriptionService.UpdatePrescription(prescriptionDetails).subscribe({
          next: (res: any) => {
            if (!res.HasError) {
              this.spinner.hide();
              this.prescriptionDetails.Prescription = res.Prescription;
              this.drugList = res.PrescriptionDetails;
              // this.comments = this.prescriptionDetails.Prescription.Comment;
              this.prescriptionDetails.drugList = this.drugList;
              if (
                this.prescriptionDetails.Prescription.IsReadyToCollect == true
              ) {
                this.getReplaceItemListById(
                  this.prescriptionDetails.Prescription?.Id
                );
                this.getDrugListByPrescriptionId(
                  this.prescriptionDetails.Prescription?.Id
                );
              }
              this.authService.showNotification(
                "snackbar-success",
                "Prescription status updated successfully.",
                "top",
                "center"
              );
              this.notificationService.SendPrescription(
                this.prescriptionDetails.Prescription
              );
              if (this.prescriptionDetails.Prescription.Status == "FILLED") {
                let title = "Your prescription has been filled.";
                let description = `Prescription ${
                  this.prescriptionDetails.Prescription.PrescriptionNo
                } has been successfully filled for ${
                  this.prescriptionDetails.Patient.FirstName +
                  " " +
                  this.prescriptionDetails.Patient.LastName
                }.`;
                this.AddNotification(title, description);
                this.AddUserActivity(
                  ActivityType.FillPrescription,
                  this.prescriptionDetails.Prescription.PrescriptionNo,
                  "filled "
                );
              } else if (
                this.prescriptionDetails.Prescription.Status ==
                "PARTIALLY FILLED"
              ) {
                let title = "Your prescription has been partially filled.";
                let description = `Prescription ${
                  this.prescriptionDetails.Prescription.PrescriptionNo
                } has been partially filled for ${
                  this.prescriptionDetails.Patient.FirstName +
                  " " +
                  this.prescriptionDetails.Patient.LastName
                }.`;
                this.AddNotification(title, description);
                this.AddUserActivity(
                  ActivityType.PartiallyFillPrescription,
                  this.prescriptionDetails.Prescription.PrescriptionNo,
                  "partially filled "
                );
              }
              if (
                this.prescriptionDetails.Prescription.IsReadyToCollect == true
              ) {
              } else {
                this.router.navigate(["/pharmacist/dashboard"]);
              }
            } else {
              this.spinner.hide();
              this.authService.showNotification(
                "snackbar-danger",
                "Error updating prescription",
                "top",
                "center"
              );
            }
          },
          error: () => {
            this.authService.showNotification(
              "snackbar-danger",
              "Something went wrong",
              "top",
              "center"
            );
            this.spinner.hide();
          },
        });
    } else {
      this.prescriptionDetails.Prescription.IsReadyToCollect = !this
        .prescriptionDetails.Prescription.IsReadyToCollect;
      this.authService.showNotification(
        "snackbar-danger",
        "Please, fill at least one drug.",
        "top",
        "center"
      );
    }
  }

  ChangePrescriptionStatus(prescriptionDetails, status) {
    // var changedStatus = {
    //   prescriptionId: prescriptionDetails.Id,
    //   newStatus: status,
    //   isLock: false,
    //   isLockBy: prescriptionDetails.IsLockBy,
    //   isPrinted:prescriptionDetails.IsPrinted
    // };

    var changedStatus = {
      "prescriptionDetails":{}
    };
    changedStatus.prescriptionDetails={
      "Id":prescriptionDetails.Id,
      "Status":status,
      "IsLock":prescriptionDetails.IsLock,
      "IsLockBy":prescriptionDetails.IsLockBy,
      "IsPrinted":prescriptionDetails.IsPrinted
    }

    this.spinner.show();
    this.prescriptionService.ChangePrescriptionStatus(changedStatus).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.spinner.hide();
          this.prescriptionDetails.Prescription = resp;
          this.notificationService.SendPrescription(
            this.prescriptionDetails.Prescription
          );
          this.closeDialog();
          // this.router.navigate(["/pharmacist/dashboard"]);
          this.location.back();
        } else {
          this.closeDialog();
          this.location.back();
          // this.authService.showNotification(
          //   "snackbar-danger",
          //   "something went wrong.ssssssssssssssssss",
          //   "top",
          //   "center"
          // );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  getPatientDetailsById(Id: any) {
    var patientDetails = {
      patientDetails: Id,
    };
    this.spinner.show();
    this.patientService.GetPatient(patientDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.Patient = resp;
          this.getCurrentUserDetails(this.Patient.PhysicianAccountId);
          this.spinner.hide();
        } else {
          this.authService.showNotification(
            "snackbar-danger",
            "something went wrong.",
            "top",
            "center"
          );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  Cancel() {
    this.ChangePrescriptionStatus(
      this.prescriptionDetails.Prescription,
      this.oldStatus
    );
  }

  ngOnDestroy(): void {
    // if (
    //   this.prescriptionDetails.Prescription?.Status == "IN PROGRESS" &&
    //   this.prescriptionDetails.Prescription.IsReadyToCollect == false
    // ) {
    //   this.ChangePrescriptionStatus(
    //     this.prescriptionDetails.Prescription.Id,
    //     this.oldStatus
    //   );
    // }
  }
  CancelPrescription() {
    if (this.prescriptionDetails.Prescription.IsReadyToCollect != true) {
      const dialogRef = this.dialog.open(this.CancelPrescriptionComponent, {
        maxWidth: "750px",
        disableClose: true,
      });
    } else {
      // this.router.navigate(["/pharmacist/dashboard"]);
      this.location.back();
    }
  }
  ReadyToCollect() {
    this.collectionLocation
    this.prescriptionDetails.Prescription.IsReadyToCollect = true;
    this.prescriptionDetails.Prescription.Comment = this.comments;
    this.UpdatePrescription();
  }

  Collected() {
    this.prescriptionDetails.Prescription.IsReadyToCollect = false;
    this.UpdatePrescription();
  }

  AddNotification(title, description) {
    var notification = {
      Title: title,
      Description: description,
      ReceiverAccountId: this.prescriptionDetails.doctorUserAccount.Id,
      ReceiverRoleId: userRole.doctor,
      SenderAccountId: this.currentUser.Id,
      CreatedById: this.currentUser.Id,
      IsRead: false,
    };
    var notificationDetails = {
      Notification: notification,
    };
    this.spinner.show();
    this.notificationService.AddNotification(notificationDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.notificationService.AddPortalNotification(resp);
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  subscribeToEvents() {
    this.notificationService.messageReceived.subscribe((resp: any) => {
      this._ngZone.run(() => {
        if (
          this.prescriptionDetails.Prescription?.Id == resp?.Id &&
          resp.IsLock == true &&
          resp.IsLockBy != this.currentUser.Id &&
          // this.prescriptionDetails.Prescription.Status == "IN PROGRESS" &&
          this.router.url.includes("fill")
        ) {
          const encryptedstring = this.encryptDecryptParametersService.encrypt(
            `details=${JSON.stringify({
              Id: resp.Id,
            })}`
          );
          this.router.navigateByUrl(
            // `/pharmacist/prescription/view?${encryptedstring}`
            `/pharmacist/prescription/list`
          );
        }
      });
    });
  }
  isReplaceDrugExist(drugId) {
    return this.replacedDrug.find((x) => x.OldDrugId == drugId);
  }
  getReplaceItemListById(id) {
    this.spinner.show();
    const prescriptionDetails = { prescriptionId: id };
    this.prescriptionService.GetReplaceItems(prescriptionDetails).subscribe({
      next: (res: any) => {
        if (!res.HasErrors) {
          this.replacedDrug = res.Rows;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  IsDrugExist(drugId) {
    return this.replacedDrug.find((x) => x.NewDrugId == drugId);
  }

  //summary model after ready to collect
  summaryModalView(row) {
    // TO DO API to  get patient details
    let drugs = [];
    // this.replacedDrug.forEach((element) => {
    //   if (
    //     element.NewDrugId == row.DrugId ||
    //     element.OldDrugId == row.DrugId ||
    //     element.PrescriptionDetailsId == row.Id
    //   ) {
    //     element.CreatedDate = new Date();
    //     drugs.push(element);
    // var prescribeDrug = {
    //   Status: "Prescribed",
    //   CreatedDate: this.prescriptionDetails.Prescription.CreatedDate,
    //   Name: element.OldDrugName,
    //   Description: element.OldDrugDescription,
    //   Remark: "-",
    // };
    // drugs.push(prescribeDrug);
    //   }
    // });
    for (let index = 0; index < this.replacedDrug.length; index++) {
      if (
        this.replacedDrug[index].NewDrugId == row.DrugId ||
        this.replacedDrug[index].OldDrugId == row.DrugId ||
        this.replacedDrug[index].PrescriptionDetailsId == row.Id
      ) {
        this.replacedDrug[index].CreatedDate = new Date();
        drugs.push(this.replacedDrug[index]);
      }
    }
    var prescribeDrug = {
      Status: "Prescribed",
      CreatedDate: this.prescriptionDetails.Prescription.CreatedDate,
      Name: drugs[drugs.length - 1].OldDrugName,
      Description: drugs[drugs.length - 1].OldDrugDescription,
      Refill: drugs[drugs.length - 1].OldDrugRefill,
      Remark: "-",
    };
    drugs.push(prescribeDrug);

    drugs = drugs.filter((x) => x.Name != undefined);
    const dialogRef = this.dialog.open(SummaryModalComponent, {
      data: {
        drug: drugs,
        action: "view",
      },
      width: "100%",
      maxWidth: "750px",
      disableClose: true,
    });
  }

  NotCollected() {
    var prescriptionDetails = {
      prescriptionId: this.prescriptionDetails.Prescription.Id,
    };
    this.prescriptionService
      .NotCollectedPrescription(prescriptionDetails)
      .subscribe({
        next: (resp: any) => {
          if (!resp.HasError) {
            this.router.navigateByUrl("/pharmacist/dashboard");
          }
        },
        error: () => {},
      });
  }
  GetRemark(drugId) {
    return this.replacedDrug.find((x) => x.NewDrugId == drugId);
  }
  AddUserActivity(activityType, prescriptionNo, activityName) {
    var userActivity = {
      ActivityType: activityType,
      ActivityName: activityName,
      UserName: this.currentUser.FirstName + " " + this.currentUser.LastName,
      Description:
        this.currentUser.FirstName +
        " " +
        this.currentUser.LastName +
        " " +
        activityName +
        " prescription " +
        prescriptionNo,
      UserAccountId: this.currentUser.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }

  AddUserActivityForNotCollected(activityType, activityName, description) {
    var userActivity = {
      ActivityType: activityType,
      ActivityName: activityName,
      UserName: this.currentUser.FirstName + " " + this.currentUser.LastName,
      Description: description,
      UserAccountId: this.currentUser.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }


  getCollectionLocation() {
    const doc = 
    { 
      collectionLocation: 
      {
        userAccountId: this.currentUser.Id
      }
    };
    this.appService.getCollectionlocations(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.collectionLocationkey = JSON.parse(res.CollectionLocation)
          var newArray:any =[];
            for(let key in this.collectionLocationkey)
            {
              this.collectionLocationList.push({key:key,value:this.collectionLocationkey[key]})
            }
      }
    });
  }

  enterCollectionLocation(tags:any,forSearch:boolean) {
    
    if(tags.searchTerm)
    {
    this.collectionLocation
    if(!forSearch)
    {
      if(this.collectionLocation?.length!=0)
      {
        for (let members of this.collectionLocation) {
          if (members != tags.searchTerm) {
            this.collectionLocation = [...this.collectionLocation, tags.searchTerm]
            return
          }
        }
      }
      else
      {
        this.collectionLocation = tags.searchTerm
        for (let members of this.collectionLocation) {
          if (members != tags.searchTerm) {
            this.collectionLocation = [...this.collectionLocation, tags.searchTerm]
            return
          }
        }
        return
      }
    } 
  }
  }

  
clicktoconver()
{
  this.collectionLocation
}

printPrescription()
{
  const dialogRef = this.dialog.open(this.printPrescriptionConfirm, {
    data: {
      doctor: "nikhil demo",
      action: "delete",
    },
    width: "100%",
    height: "250px",
    maxWidth: "600px",
    disableClose: true,
  });
  dialogRef.afterClosed().subscribe((result) => {
    if (result === 1) {
      this.authService.showNotification(
        "snackbar-success",
        "Delete Record Successfully.",
        "bottom",
        "center"
      );
    }
  });
}


prescriptionStatusChange(row:any)
{
  this.closeDialog();
  this.spinner.show();

  this.downloadPrescription(row)
  this.spinner.hide();
}
prescriptionNotStatusChange(row:any)
{
  this.closeDialog();
  this.spinner.hide();
  this.downloadPrescription(row)
}

// Pricription PDF
downloadPrescription(row: any) { 
  this.spinner.show();
  var prescriptionDetails = {
    prescriptionDetails: row.Prescription.Id,
  };
  this.prescriptionService
    .DownloadPrescription(prescriptionDetails)
    .subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.closeDialog();
          this.pdfstring = resp.pdf;
          this.downloadFile(this.pdfstring, "application/pdf", "download");
          this.AddUserActivity(
            this.currentUser.FirstName + " " + this.currentUser.LastName,
            this.currentUser.Id,
            ActivityType.DownloadPrescription,
            // "Download Prescription",
            // "Prescription " + row.Prescription.PrescriptionNo + " is downloaded by " + this.currentUser.FirstName +
            //   " " +
            //   this.currentUser.LastName
          );
         // this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
}

downloadFile(data: string, fileType: any, type: string): void {
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType });
  const url  = window.URL.createObjectURL(blob);
  if (type === "print") {
    window.location.href = url;
  } else {
    const downloadPDF = document.createElement("a");
    downloadPDF.href = url;
    downloadPDF.download = "Prescription_" + new Date() + ".pdf";
    downloadPDF.click();
  }
}

}
